<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import mdiArrowLeft from '~icons/mdi/arrow-left'

import { WIZARD_PAGES, type WizardPage } from './types'

// Navigation toolbar for the multi-mode Select/Setup flow (ported from @old AmortizationBackToolbar).
// The page counter derives from WIZARD_PAGES — no literal page count in the template (PR #896 review).
// On the first page the back button is not rendered at all: a disabled control that can never
// enable on that page says nothing (Anton, ADA-4457 test round); `ml-auto` keeps the counter right.
const props = defineProps<{ page: WizardPage }>()

const emit = defineEmits<{ back: [] }>()

const { t } = useI18n()

const pageNumber = computed(() => WIZARD_PAGES.indexOf(props.page) + 1)
</script>

<template>
  <div class="d-flex justify-space-between align-center px-4 mb-4">
    <v-btn
      v-if="pageNumber > 1"
      variant="text"
      class="pa-1"
      @click="emit('back')"
    >
      <template #prepend>
        <v-icon :icon="mdiArrowLeft" />
      </template>
      {{ t('common.back') }}
    </v-btn>
    <div class="ml-auto text-body-small text-medium-emphasis">{{ pageNumber }}/{{ WIZARD_PAGES.length }}</div>
  </div>
</template>
